module.exports = "\n<nav mat-tab-nav-bar>\n    <a mat-tab-link\n       *ngFor=\"let link of inNavLinks\"\n       routerLinkActive #rla=\"routerLinkActive\"\n       [active]=\"rla.isActive\"\n       (click)=\"setLevel(link.level)\" >\n      {{link.label}}\n    </a>\n</nav>\n\n<!-- [routerLink]=\"link.path\" -->\n  "


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/levels/levels.component.html
// module id = ../../../../../src/app/levels/levels.component.html
// module chunks = main